import { Error } from "./../common/error";
export class Base {
    hasError:boolean;
    errorNumber:Number;
    error:Error;


}
